var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.userFetched)?_c('div',[_c(_vm.activeUserAction.component,_vm._b({tag:"component"},'component',_vm.activeUserAction.props,false))],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }